import React from "react";
import { Component } from "react";
import { InputField } from "../../../../common/custom-form/input-filter-component";
import { Button } from "react-bootstrap";
import { DetailsDataTable } from "../../../inventory/DetailsView/details-table/details-table.component";
import DATEPICKER_OR from "../../../../common/custom-form/custom-date-picker.component";

export class AccountPurchaseOrder extends Component {
    constructor(props) {
        super(props);
        this.state={
            inputValue:"",
            showTable:false,
            invoiceApproveDate:""
        }
    }
    ShowTable() {
        this.setState({showTable:!this.showTable})
    }
    render() {
        return(
            <div className="">
                <div className="grid-3-1fr-column">
                <InputField label="PO NUMBER" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})} />                
                <DATEPICKER_OR label="Validate From" startDate={this.state.invoiceApproveDate} dateSelected={this.state.invoiceApproveDate} selectedDate={(date) => this.setState({invoiceApproveDate:date})}/>
                <div></div>
                <InputField label="PO VALUE" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})} />
                <DATEPICKER_OR label="Validate To" startDate={this.state.invoiceApproveDate} dateSelected={this.state.invoiceApproveDate} selectedDate={(date) => this.setState({invoiceApproveDate:date})}/>
                <div className="add-button-container ">
                    <Button>Cancel</Button>
                    <Button onClick={this.ShowTable.bind(this)}>Add</Button>
                </div>                
            </div>
                {
                    this.state.showTable && 
                    <DetailsDataTable datatable={this.props.datatable} haveEditBtn={this.props.haveEditBtn} haveDeleteBtn={this.props.haveDeleteBtn} />       
                }
         </div>
        );
    }
}